import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-body1" }

import { date } from "quasar"
import SfxCardEventBase from "src/components/card/SfxCardEventBase.vue"
import SfxUserData from "src/components/special/SfxUserData.vue"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getUserWithAvatarData } from "src/util/functions/user"
import { IssueCorrectiveWorkRejectedEventCard } from "src/util/types/dataModels/issue"
import { UserWithAvatar } from "src/util/types/dataModels/user"
import { computed, onBeforeMount, PropType, ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardIssueEventWorkRejected',
  props: {
  issueEventCard: {
    type: Object as PropType<IssueCorrectiveWorkRejectedEventCard>,
    required: true,
  },

  manager: {
    type: Boolean,
    default: false,
  },

  showHand: {
    type: Boolean,
    default: true,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const correctedTime = computed(() =>
  date.formatDate(props.issueEventCard.correctedDate, DATE_TIME_FULL_MASK)
)
const captionClass = computed(() => (props.manager ? "text-body1" : "text-caption"))
const iconSize = computed(() => (props.manager ? "32px" : "24px"))
const userDataClosed = ref<UserWithAvatar>()
const userDataCorrected = ref<UserWithAvatar>()

//endregion

//region Lifecycle

onBeforeMount(async () => {
  userDataClosed.value = await getUserWithAvatarData(props.issueEventCard?.userIdClosed)
  userDataCorrected.value = await getUserWithAvatarData(props.issueEventCard?.userIdCorrected)
})

//endregion

//region Functions

function handleClick() {
  emit("click")
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(SfxCardEventBase, {
    title: _ctx.$t('sfxCard.title_corrective_work_rejected'),
    createdDate: props.issueEventCard.rejectedDate,
    manager: props.manager,
    class: "sfx-card-issue-status--work-rejected",
    clickable: "",
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-fun-label-and-icon", captionClass.value])
          }, _toDisplayString(_ctx.$t("sfxCard.corrected_on_date_by", { date: correctedTime.value })), 3),
          _createVNode(SfxUserData, { "user-data": userDataCorrected.value }, null, 8, ["user-data"])
        ]),
        (props.showHand)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_q_space),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_q_icon, {
                  name: _unref(Icons).CLICKABLE,
                  size: iconSize.value
                }, null, 8, ["name", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-fun-label-and-icon", captionClass.value])
        }, _toDisplayString(_ctx.$t("sfxCard.rejection_reason")), 3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.issueEventCard.reason), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-fun-label-and-icon", captionClass.value])
        }, _toDisplayString(_ctx.$t("sfxCard.by")), 3),
        _createVNode(SfxUserData, { "user-data": userDataClosed.value }, null, 8, ["user-data"])
      ])
    ]),
    _: 1
  }, 8, ["title", "createdDate", "manager"]))
}
}

})